import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';
import { Dataset, DatasetCsvReference } from '@/types/source-types';
import { normalizeDatasetCsvReference } from './normalize-dataset-csv-reference';

interface CreateDatasetPayload {
  name: string;
  description?: string;
  csv_object_keys: DatasetCsvReference[];
}

interface CreateDatasetResponse {
  dataset: Dataset;
}

export const createDataset = async (
  collectionId: string,
  payload: CreateDatasetPayload,
) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<CreateDatasetResponse>({
    url: `/collections/${orgId}/${collectionId}/datasets`,
    method: 'POST',
    target: 'platform',
    body: {
      name: payload.name,
      ...(payload.description ? { description: payload.description } : {}),
      csv_object_keys: payload.csv_object_keys.map((reference) =>
        normalizeDatasetCsvReference(reference),
      ),
    },
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to create dataset',
    };
  }

  return response?.data?.dataset;
};
